/*
 * Author: PMS
 * Title: D1 Form: Medicine list cache + request dedupe
 * Description: Module-level cache so the D1 category tables render instantly.
 *              The background warm-up loop and the mounted table share the
 *              same in-flight promise, so each category/month/year combo is
 *              fetched only once. The cache is keyed by month/year so that
 *              switching the form's Month/Year picker never reuses stale data.
 * Date: 16/08/2026
 */

const cache = new Map();
const inflight = new Map();

const buildKey = (id, params) => {
  const month = params?.month ?? "";
  const year = params?.year ?? "";
  return `${id}_${month}_${year}`;
};

export const getCached = (id, params) => cache.get(buildKey(id, params));

export const getMedicineList = (id, fetcher, params) => {
  const key = buildKey(id, params);
  if (cache.has(key)) {
    return Promise.resolve(cache.get(key));
  }
  if (!inflight.has(key)) {
    inflight.set(
      key,
      fetcher(id, params)
        .then((data) => {
          cache.set(key, data);
          inflight.delete(key);
          return data;
        })
        .catch((err) => {
          inflight.delete(key);
          throw err;
        })
    );
  }
  return inflight.get(key);
};

export const clearMedicineCache = () => {
  cache.clear();
};
